const YellowStar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.18913 2.50201C7.34174 2.19449 7.65542 2 7.99871 2C8.34201 2 8.65569 2.19449 8.8083 2.50201L10.3849 5.67885L13.8935 6.19661C14.2331 6.24674 14.515 6.48495 14.6211 6.81143C14.7272 7.13796 14.6391 7.49636 14.3938 7.73655L11.8597 10.2177L12.4515 13.7146C12.5087 14.053 12.3693 14.3947 12.0916 14.5966C11.8138 14.7984 11.4457 14.8253 11.1415 14.6663L7.99871 13.0229L4.85589 14.6663C4.55164 14.8253 4.18354 14.7984 3.90581 14.5966C3.62807 14.3947 3.48864 14.053 3.54596 13.7146L4.13774 10.2177L1.60358 7.73655C1.35826 7.49636 1.27019 7.13796 1.37631 6.81143C1.48237 6.48495 1.76428 6.24674 2.10393 6.19661L5.6125 5.67885L7.18913 2.50201Z"
      fill="url(#paint0_linear_2701_48292)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2.04688C8.3433 2.04688 8.65698 2.24137 8.80958 2.54889L10.3862 5.72572L13.8948 6.24348C14.2344 6.29362 14.5163 6.53182 14.6224 6.8583C14.6241 6.86355 14.6257 6.86875 14.6273 6.874L8 9.01006V2.04688Z"
      fill="url(#paint1_linear_2701_48292)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99843 9.01006L1.37109 6.874C1.37265 6.86875 1.37431 6.86355 1.37602 6.8583C1.48208 6.53182 1.76399 6.29362 2.10365 6.24348L5.61221 5.72572L7.18885 2.54889C7.34145 2.24137 7.65513 2.04688 7.99843 2.04688V9.01006Z"
      fill="url(#paint2_linear_2701_48292)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0991 14.578C12.0907 14.5844 12.0823 14.5907 12.0736 14.5969C11.7959 14.797 11.4279 14.8238 11.1236 14.6661L7.98079 13.0367L4.83796 14.6661C4.53896 14.8211 4.17831 14.7979 3.90234 14.6071L7.98079 9.01172L12.0991 14.578Z"
      fill="url(#paint3_linear_2701_48292)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2701_48292"
        x1="7.99871"
        y1="7.13716"
        x2="7.99871"
        y2="13.6754"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB541" />
        <stop offset="1" stopColor="#F59500" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2701_48292"
        x1="7.77677"
        y1="2.34218"
        x2="12.4845"
        y2="8.8092"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD952" />
        <stop offset="1" stopColor="#FFA501" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2701_48292"
        x1="4.37416"
        y1="3.26359"
        x2="8.80208"
        y2="7.46728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDF6C" />
        <stop offset="1" stopColor="#FFA501" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2701_48292"
        x1="8.00071"
        y1="6.67221"
        x2="8.00071"
        y2="13.6577"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA841" />
        <stop offset="1" stopColor="#F27B00" />
      </linearGradient>
    </defs>
  </svg>
);

export default YellowStar;
